import { useState } from 'react';

export default function useRoomState() {
  const [settings, setSettings] = useState({
    videoInputId: '',
    environmentVideoInputId: '',
    audioInputId: '',
    audioOutputId: '',
    videoInputEnabled: true,
    audioInputEnabled: true,
    blurInput: true,
  });

  return { settings, setSettings };
}
